import React from 'react';
import styled from 'styled-components';
import Tooltip from '../../Tooltip';
import Icon from '../../Icon';

const TableHeaderContainer = styled.div`
  display: flex;
  padding: 7px;
  border: 1px solid rgba(31, 43, 55, 0.1);
  border-bottom: 2px solid ${(props) => props.theme.colors['terra-cotta']};
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 100%;
  outline: none !important;
  min-height: 50px;

  &:hover {
    cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};
  }

  .title {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 12px;
    text-transform: uppercase;
    color: ${(props) => props.theme.colors['dark-two']};
  }

  .tableHeaderTag {
    color: rgba(31, 43, 55, 0.3);
  }

  .sortIconContainer {
    margin-left: 3px;
  }

  .sortIconContainer:hover {
    cursor: pointer;
  }

  .tableHeaderTooltipContainer {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  ${(props) => props.styles}
`;

const TableHeader = (props) => {
  const inside = (
    <React.Fragment>
      <div>
        <p className="title">{props.title}</p>
        {props.tag && <p className="title tableHeaderTag">({props.tag})</p>}
      </div>
      {props.sortable && (
        <div
          className="sortIconContainer"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            props.sort();
          }}
        >
          <Icon icon="sort" />
        </div>
      )}
    </React.Fragment>
  );

  return props.tooltip ? (
    <TableHeaderContainer styles={props.styles}>
      <Tooltip {...props.tooltip}>
        <div className="tableHeaderTooltipContainer">{inside}</div>
      </Tooltip>
    </TableHeaderContainer>
  ) : (
    <TableHeaderContainer
      isClickable={props.onClick}
      onClick={props.onClick ? () => props.onClick() : undefined}
      styles={props.styles}
    >
      {inside}
    </TableHeaderContainer>
  );
};

export default TableHeader;
